/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_Salary_DescInputs */

const en_landing_tab_salary_desc = /** @type {(inputs: Landing_Tab_Salary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know your market value before negotiating. Get real salary data, percentile rankings, and AI-generated talking points tailored to your experience.`)
};

const de_landing_tab_salary_desc = /** @type {(inputs: Landing_Tab_Salary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenne deinen Marktwert vor der Verhandlung. Echte Gehaltsdaten, Perzentil-Rankings und KI-generierte Argumente für deine Erfahrung.`)
};

const fr_landing_tab_salary_desc = /** @type {(inputs: Landing_Tab_Salary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know your market value before negotiating. Get real salary data, percentile rankings, and AI-generated talking points tailored to your experience.`)
};

const es_landing_tab_salary_desc = /** @type {(inputs: Landing_Tab_Salary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know your market value before negotiating. Get real salary data, percentile rankings, and AI-generated talking points tailored to your experience.`)
};

const it_landing_tab_salary_desc = /** @type {(inputs: Landing_Tab_Salary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know your market value before negotiating. Get real salary data, percentile rankings, and AI-generated talking points tailored to your experience.`)
};

const nl_landing_tab_salary_desc = /** @type {(inputs: Landing_Tab_Salary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know your market value before negotiating. Get real salary data, percentile rankings, and AI-generated talking points tailored to your experience.`)
};

const pl_landing_tab_salary_desc = /** @type {(inputs: Landing_Tab_Salary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know your market value before negotiating. Get real salary data, percentile rankings, and AI-generated talking points tailored to your experience.`)
};

const fi_landing_tab_salary_desc = /** @type {(inputs: Landing_Tab_Salary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know your market value before negotiating. Get real salary data, percentile rankings, and AI-generated talking points tailored to your experience.`)
};

const da_landing_tab_salary_desc = /** @type {(inputs: Landing_Tab_Salary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know your market value before negotiating. Get real salary data, percentile rankings, and AI-generated talking points tailored to your experience.`)
};

const sv_landing_tab_salary_desc = /** @type {(inputs: Landing_Tab_Salary_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Know your market value before negotiating. Get real salary data, percentile rankings, and AI-generated talking points tailored to your experience.`)
};

/**
* | output |
* | --- |
* | "Know your market value before negotiating. Get real salary data, percentile rankings, and AI-generated talking points tailored to your experience." |
*
* @param {Landing_Tab_Salary_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_salary_desc = /** @type {((inputs?: Landing_Tab_Salary_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_Salary_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_salary_desc(inputs)
	if (locale === "fr") return fr_landing_tab_salary_desc(inputs)
	if (locale === "es") return es_landing_tab_salary_desc(inputs)
	if (locale === "it") return it_landing_tab_salary_desc(inputs)
	if (locale === "nl") return nl_landing_tab_salary_desc(inputs)
	if (locale === "pl") return pl_landing_tab_salary_desc(inputs)
	if (locale === "fi") return fi_landing_tab_salary_desc(inputs)
	if (locale === "da") return da_landing_tab_salary_desc(inputs)
	if (locale === "sv") return sv_landing_tab_salary_desc(inputs)
	return en_landing_tab_salary_desc(inputs)
});